import React from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';

import { useGroupedAutocompleteStyles } from 'shared/styles/groupedAutocompleteStyles/groupedAutocompleteStyles';

const GroupedSelect = ({
  onChange,
  value,
  options,
  label,
  getOptionLabel,
  groupBy,
  multiple,
  ...props
}) => {
  const groupedAutocompleteClasses = useGroupedAutocompleteStyles();

  const handleChange = (_event, val) => onChange(val);

  return (
    <Autocomplete
      {...props}
      multiple={multiple}
      options={options}
      onChange={handleChange}
      getOptionLabel={getOptionLabel}
      groupBy={groupBy}
      value={value}
      renderInput={params => <TextField {...params} label={label} variant="outlined" />}
      renderTags={(values, getTagProps) =>
        values.map((option, index) => <Chip label={option.name} {...getTagProps({ index })} />)
      }
      classes={groupedAutocompleteClasses}
    />
  );
};

GroupedSelect.defaultProps = {
  multiple: false,
  value: null,
};

GroupedSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
      }),
    ),
  ]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  label: PropTypes.string.isRequired,
  getOptionLabel: PropTypes.func.isRequired,
  groupBy: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
};

export default GroupedSelect;
